<template>
  <Home :isAdminPage="true" />
  <!-- <Home v-if="userInfo.isAdmin" :isAdminPage="true" /> -->
  <!-- <no-permission v-else text="抱歉，您无管理权限" /> -->
</template>

<script>
import { mapGetters } from 'vuex';
import NoPermission from '@/components/noPermission.vue';
import Home from './home';

export default {
  name: "QiDianAdmin",
  components: {
    Home,
    NoPermission
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    console.log('userInfo========', this.userInfo);
  }
};
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/view/QiDian/Admin.vue